export class ProdVolHistory {
    siteId: number;
    prodGas: string;
    volume: number;
    prodVolUom: string;
    prodvolreason: string;
    supplyType: string;
    volumeSource: string;
    comments: string;
    onstreamDate?: Date;
    expansionDate?: Date;
    insertedDate: string;
    insertedBy: string;
    modifiedDate: string;
    modifiedBy: string;
    constructor(siteID) {
        this.siteId = siteID;
    }
}

export class ProdGas {
    name: string;
}

export class ProdVolReason{
    reason : string;
}